import {
  CountryOptions,
  deviceAccessoriesOptions,
  devicesMembershipOptions,
  hvacOptions,
  MessageDeliveryStatusOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"

import RowExpandToggle from "components/table/columnComponents/RowExpandToggle"
import { StatusOfMessageReport } from "components/table/columnComponents/StatusOfMessageReport"

export const messageReportHeaderCells: UITypes.TableHeaderCell[] = [
  { title: "", size: "mini", name: "group_toggle", cellComponent: RowExpandToggle },
  {
    title: "S/N",
    type: "sort-search",
    name: "sn",
    size: "small",
  },
  {
    title: "Customer name",
    type: "sort-search",
    size: "middle",
    name: "client_name",
  },
  {
    title: "Schedule date",
    type: "default",
    size: "middle",
    name: "scheduled_at",
    cellComponent: "datetime",
  },
  {
    title: "Delivery date",
    type: "default",
    size: "middle",
    name: "delivered_at",
    cellComponent: "datetime",
  },
  {
    title: "Status",
    type: "select",
    size: "small",
    name: "delivery_status",
    cellComponent: StatusOfMessageReport,
    options: MessageDeliveryStatusOptions,
  },
  {
    title: "Country",
    type: "select",
    size: "small",
    name: "country",
    options: CountryOptions,
  },
  {
    title: "City",
    type: "sort-search",
    size: "small",
    name: "city",
  },
  {
    title: "Zip code",
    type: "sort-search",
    size: "small",
    name: "zip",
  },
  {
    title: "State",
    type: "sort-search",
    size: "small",
    name: "state",
  },
  {
    title: "Activation date",
    type: "sort-date",
    size: "middle",
    name: "activation_date",
  },
  {
    title: "Membership",
    type: "select",
    size: "small",
    name: "membership",
    options: devicesMembershipOptions,
  },
  {
    title: "Residence type",
    type: "sort-search",
    size: "middle",
    name: "residence_type",
  },
  {
    title: "System type",
    type: "sort-search",
    size: "small",
    name: "system_type",
  },
  {
    title: "System age",
    type: "sort-search-number",
    size: "middle",
    name: "system_age",
  },
  {
    title: "Accessories",
    type: "select",
    size: "small",
    name: "accessories",
    options: deviceAccessoriesOptions,
  },
  {
    title: "HVAC",
    type: "select",
    size: "small",
    name: "installation_type",
    options: hvacOptions,
  },
]
